// Should be same class as in back-end
export class AccountIdentifierConstants {
  public static readonly Email = 'email';
  public static readonly Telephone = 'telephone';
  public static readonly VoyadoContactId = 'voyadoContactId';
}
